<div class="tabs">

  <div class="tab" [class.active]="tabs.active==='user'" (click)="tabs.active='user'">
    <h6><i class="fa fa-fw fa-users"></i>
    <span class="hide-mobile">
      Users
      @if (users) {
        <span class="count">
          ({{users.length}})
        </span>
      }
    </span>
  </h6>
</div>
<div class="tab" [class.active]="tabs.active==='org'" (click)="tabs.active='org'">
  <h6><i class="fa fa-fw fa-sitemap"></i>
  <span class="hide-mobile">
    Orgs
  </span>
</h6>
</div>
<div class="tab" [class.active]="tabs.active==='gateway'" (click)="tabs.active='gateway'">
  <h6><i class="fa fa-fw fa-microchip"></i>
  <span class="hide-mobile">
    Gateways
    @if (gateways) {
      <span class="count">
        {{gateways.length}}
      </span>
    }
  </span>
</h6>
</div>
<div class="tab" [class.active]="tabs.active==='asset'" (click)="tabs.active='asset'">
  <h6><i class="fa fa-fw fa-cubes"></i>
  <span class="hide-mobile">
    Assets
    @if (assets) {
      <span class="count">
        {{assets.length}}
      </span>
    }
  </span>
</h6>
</div>
</div>

<div class="tab-container">
  <div class="shared">
    <button (click)="create(tabs.active)"> <span class="mdi mdi-pencil-plus-outline"></span> Create
  {{tabs.active}}</button>
</div>
@if (tabs.active === 'org') {
  <div>
    <table class="">
      <thead>
        <tr>
          <th>Title</th>
          <th>Short</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        @for (org of orgs; track org) {
          <tr (click)="edit(org)">
            <td>{{org.title}}</td>
            <td>{{org.shortTitle}}</td>
            <td>{{org.isActive ? 'Enabled' : 'Disabled'}}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
@if (tabs.active === 'user') {
  <div>
  </div>
}
@if (tabs.active === 'gateway') {
  <div>
  </div>
}
</div>

@if (createObject) {
  <div class="popup">
    <app-manage-create [object]="createObject" (didSave)="saved()"></app-manage-create>
  </div>
}
